(function () {
  'use strict';

  angular
    .module('crewSetReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('crewSetReport', {
        url: '/crew-set-report',
        views : {
        	'crewSetReportView' : {
        		templateUrl: 'crew-set-report/views/crew-set-report.tpl.html',
                controller: 'CrewSetReportCtrl',
                controllerAs: 'crewSetReport'
        	}
        }
      });
  }
}());
